// 用戶user
import { request } from '@/utils/service'

/** 查询诊所详情 */
export function getClinic(params?: Record<string, any>) {
  return request<Record<string, any>>({
    url: 'UserApi/Clinic/GetClinic',
    method: 'get',
    params,
  })
}
/** 获取用户信息 */
export function getStaff(params?: string) {
  return request<Record<string, any>>({
    url: 'UserApi/Staff/GetStaff',
    method: 'get',
    params,
  })
}
/** 【Organization,Clinic】查询字典列表 */
export function getDictList(params: Record<string, any>, options?: Record<string, any>) {
  return request<Record<string, any>>(
    {
      url: 'UserApi/Dict/GetDictList',
      method: 'get',
      params,
    },
    options,
  )
}
/** 【Organization】修改字典起停 */
export function updateDictIsEnable(params?: string) {
  return request<Record<string, any>>({
    url: 'UserApi/Dict/UpdateDictIsEnable',
    method: 'post',
    params,
  })
}
/** 查询诊所列表 */
export function getClinicPageList(params: Object) {
  return request<Record<string, any>>({
    url: 'UserApi/Clinic/GetClinicPageList',
    method: 'post',
    params,
  })
}
/** 保存用户 */
export function saveStaff(params: Object) {
  return request({
    url: 'UserApi/Staff/SaveStaff',
    method: 'post',
    params,
  })
}
/** 获取诊所诊治配置 */
export function getClinicDiagnosisConfig(params?: string) {
  return request<Record<string, any>>({
    url: 'UserApi/Clinic/GetClinicDiagnosisConfig',
    method: 'get',
    params,
  })
}
/** 保存诊所诊治配置 */
export function saveClinicDiagnosisConfig(params: Object) {
  return request({
    url: 'UserApi/Clinic/SaveClinicDiagnosisConfig',
    method: 'post',
    params,
  })
}
/** 获取诊所配药配置 */
export function getClinicDispensingConfig(params?: string) {
  return request<Record<string, any>>({
    url: 'UserApi/Clinic/GetClinicDispensingConfig',
    method: 'get',
    params,
  })
}
/** 保存诊所配药配置 */
export function saveClinicDispensingConfig(params: Object) {
  return request({
    url: 'UserApi/Clinic/SaveClinicDispensingConfig',
    method: 'post',
    params,
  })
}
/** 获取诊所打印配置 */
export function getClinicPrintConfig(params?: string) {
  return request<Record<string, any>>({
    url: 'UserApi/Clinic/GetClinicPrintConfig',
    method: 'get',
    params,
  })
}
/** 保存诊所打印配置 */
export function saveClinicPrintConfig(params: Object) {
  return request({
    url: 'UserApi/Clinic/SaveClinicPrintConfig',
    method: 'post',
    params,
  })
}
/** 查询诊所编号配置 */
export function getClinicNoConfig(params?: string) {
  return request<Record<string, any>>({
    url: 'UserApi/Clinic/GetClinicNoConfig',
    method: 'get',
    params,
  })
}
/** 保存诊所编号配置 */
export function saveClinicNoConfig(params: Object) {
  return request({
    url: 'UserApi/Clinic/SaveClinicNoConfig',
    method: 'post',
    params,
  })
}
/** 查询诊所号源生成配置 */
export function getClinicSourceConfig(params?: string) {
  return request<Record<string, any>>({
    url: 'UserApi/Clinic/GetClinicSourceConfig',
    method: 'get',
    params,
  })
}
/** 保存诊所号源生成配置 */
export function saveClinicSourceConfig(params: Object) {
  return request({
    url: 'UserApi/Clinic/SaveClinicSourceConfig',
    method: 'post',
    params,
  })
}
/** 分页查询排班规则 */
export function getSchedulingPageList(params?: string) {
  return request<Record<string, any>>({
    url: 'UserApi/Scheduling/GetSchedulingPageList',
    method: 'post',
    params,
  })
}
/** 保存排班规则 */
export function saveScheduling(params: Object) {
  return request({
    url: 'UserApi/Scheduling/SaveScheduling',
    method: 'post',
    params,
  })
}
/** 删除排班规则 */
export function deleteScheduling(params: Object) {
  return request({
    url: 'UserApi/Scheduling/DeleteScheduling',
    method: 'get',
    params,
  })
}
/** 获取组织信息 */
export function getOrg(params?: Record<string, any>, option?: Record<string, any>) {
  return request<Record<string, any>[]>(
    {
      url: 'UserApi/Login/GetOrg',
      method: 'get',
      params,
    },
    {
      ...option, // 兼容旧版本
    },
  )
}
/** 获取診所信息 */
export function getLoginClinic(params?: Record<string, any>, option?: Record<string, any>) {
  return request<Record<string, any>[]>(
    {
      url: 'UserApi/Login/GetClinic',
      method: 'get',
      params,
    },
    {
      ...option, // 兼容旧版本
    },
  )
}
// end【Organization】分页获取用户列表 */
export function getOrgStaffPageList(params: Record<string, any>, options?: Record<string, any>) {
  return request<Record<string, any>>(
    {
      url: 'UserApi/Staff/GetOrgStaffPageList',
      method: 'post',
      params,
    },
    options,
  )
}
/** 修改用户启用状态 */
export function updateIsEnable(params: Record<string, any>, options?: Record<string, any>) {
  return request(
    {
      url: 'UserApi/Staff/UpdateIsEnable',
      method: 'post',
      params,
    },
    options,
  )
}
/** 设置诊所人员 */
export function setStaffClinic(params: Record<string, any>, options?: Record<string, any>) {
  return request(
    {
      url: 'UserApi/Staff/SetStaffClinic',
      method: 'post',
      params,
    },
    options,
  )
}
/** 保存排班规则 */
export function saveStaffScheduling(params: Object) {
  return request<Record<string, any>[]>({
    url: 'UserApi/Staff/SaveStaffScheduling',
    method: 'post',
    params,
  })
}
/** 删除排班规则 */
export function deleteStaffScheduling(params: Object) {
  return request<Record<string, any>[]>({
    url: 'UserApi/Staff/DeleteStaffScheduling',
    method: 'post',
    params,
  })
}
/** 修改密码 */
export function updatePassword(params: Object) {
  return request({
    url: 'UserApi/Staff/UpdatePassword',
    method: 'post',
    params,
  })
}
/** 重置密码 */
export function resetPassword(params: Object) {
  return request({
    url: 'UserApi/Staff/ResetPassword',
    method: 'post',
    params,
  })
}
/** 查询角色列表 */
export function getRoleList(params?: Object) {
  return request<Record<string, any>[]>({
    url: 'UserApi/Role/GetRoleList',
    method: 'get',
    params,
  })
}
/** 保存角色 */
export function saveRole(params: Object) {
  return request({
    url: 'UserApi/Role/SaveRole',
    method: 'post',
    params,
  })
}
/** 删除角色及相关数据 */
export function deleteRole(params?: Object) {
  return request<Record<string, any>[]>({
    url: 'UserApi/Role/DeleteRole',
    method: 'get',
    params,
  })
}
/** 设置权限角色 */
export function setStaffRole(params: Object) {
  return request({
    url: 'UserApi/Staff/SetStaffRole',
    method: 'post',
    params,
  })
}
/** 查询推荐列表 */
export function getPromotionList(params?: Object) {
  return request<Record<string, any>[]>({
    url: 'UserApi/Promotion/GetPromotionList',
    method: 'get',
    params,
  })
}
/** 保存推荐码 */
export function savePromotion(params: Object) {
  return request({
    url: 'UserApi/Promotion/SavePromotion',
    method: 'post',
    params,
  })
}
/** 修改推荐码状态 */
export function updatePromotionIsEnable(params: Object) {
  return request({
    url: 'UserApi/Promotion/UpdatePromotionIsEnable',
    method: 'post',
    params,
  })
}
/** 删除推荐码 */
export function deletePromotion(params: Object) {
  return request({
    url: 'UserApi/Promotion/DeletePromotion',
    method: 'get',
    params,
  })
}
/** 获取上次排班规则 */
export function getLastStaffScheduling(params: Object) {
  return request<Record<string, any>>({
    url: 'UserApi/Staff/GetLastStaffScheduling',
    method: 'post',
    params,
  })
}
/** 查询全部诊所编码 */
export function getAllClinicList(params?: Object, option?: Record<string, any>) {
  return request<Record<string, any>[]>(
    {
      url: 'UserApi/Clinic/GetAllClinicList',
      method: 'get',
      params,
    },
    {
      hasAll: true, // 返回的數組中，加上全部選項
      ...option, // 兼容旧版本
    },
  )
}
/** 分页查询充值活动列表 */
export function getValueCardMarketingPageList(params?: Record<string, any>) {
  return request<Record<string, any>>({
    url: 'UserApi/ValueCard/GetValueCardMarketingPageList',
    method: 'post',
    params,
  })
}
/** 查询储值卡活动 */
export function getValueCardMarketing(params?: Record<string, any>) {
  return request<Record<string, any>[]>({
    url: 'UserApi/ValueCard/GetValueCardMarketing',
    method: 'get',
    params,
  })
}
/** 删除储值卡活动 */
export function deleteValueCardMarketing(params?: Record<string, any>) {
  return request<Record<string, any>[]>({
    url: 'UserApi/ValueCard/DeleteValueCardMarketing',
    method: 'get',
    params,
  })
}
/** 保存储值卡活动 */
export function saveValueCardMarketing(params?: Record<string, any>) {
  return request<Record<string, any>>({
    url: 'UserApi/ValueCard/SaveValueCardMarketing',
    method: 'post',
    params,
  })
}
/** 查询患者储值卡列表 */
export function getPatientValueCardPageList(params?: Record<string, any>) {
  return request<Record<string, any>>({
    url: 'UserApi/ValueCard/GetPatientValueCardPageList',
    method: 'post',
    params,
  })
}
/** 查询患者储值卡 */
export function getPatientValueCard(params?: Record<string, any>) {
  return request<Record<string, any>>({
    url: 'UserApi/ValueCard/GetPatientValueCard',
    method: 'get',
    params,
  })
}
/** 分页查询流水 */
export function getPatientValueCardLogPageList(params?: Record<string, any>) {
  return request<Record<string, any>>({
    url: 'UserApi/ValueCard/GetPatientValueCardLogPageList',
    method: 'post',
    params,
  })
}
/** 保存字典 */
export function saveDict(params: Object) {
  return request<Record<string, any>>({
    url: 'UserApi/Dict/SaveDict',
    method: 'post',
    params,
  })
}
/** 登录 */
export function loginByAccount(params: Record<string, any>, option?: Record<string, any>) {
  return request<Record<string, any>>(
    {
      url: 'UserApi/Login/LoginByAccount',
      method: 'post',
      params,
    },
    {
      ...option, // 兼容旧版本
    },
  )
}
/** 修改诊所排班医师排序 */
export function setStaffClinicSort(params: Record<string, any>, option?: Record<string, any>) {
  return request<Record<string, any>>(
    {
      url: 'UserApi/Staff/SetStaffClinicSort',
      method: 'post',
      params,
    },
    {
      ...option, // 兼容旧版本
    },
  )
}
/**
 * 获取诊所排班人员（POST，JSON body）
 * 入参：clinicCode / employeeCategories（职工类别数组，空数组=查全部）/ isScheduling（null=不过滤）
 */
export function getSchedulingStaffs(params: Record<string, any>, option?: Record<string, any>) {
  return request<Record<string, any>[]>(
    {
      url: 'UserApi/Staff/GetSchedulingStaffs',
      method: 'post',
      params,
    },
    {
      // 该接口只接受 JSON body，强制复杂参数避免单标量被序列化成 form-urlencoded
      paramsComplexity: 'complex',
      ...option, // 兼容旧版本
    },
  )
}
/** 获取指定员工排班列表 */
export function getStaffSchedulingList(params: Record<string, any>, option?: Record<string, any>) {
  return request<Record<string, any>>(
    {
      url: 'UserApi/Staff/GetStaffSchedulingList',
      method: 'post',
      params,
    },
    {
      ...option, // 兼容旧版本
    },
  )
}
// end

/** 分页查询患者档案 */
export function getPatientPageList(params: Object) {
  return request<Record<string, any>[]>({
    url: 'UserApi/Patient/GetPatientPageList',
    method: 'post',
    params,
  })
}

/** 保存患者档案 */
export function savePatient(params: Object) {
  return request<Record<string, any>[]>({
    url: 'UserApi/Patient/SavePatient',
    method: 'post',
    params,
  })
}

/** 查询患者档案 */
export function getPatient(params: Object) {
  return request<Record<string, any>[]>({
    url: 'UserApi/Patient/GetPatient',
    method: 'get',
    params,
  })
}

/** 删除患者档案(只删除关联信息，不删除单据等) */
export function deletePatient(params: Object) {
  return request<Record<string, any>[]>({
    url: 'UserApi/Patient/DeletePatient',
    method: 'get',
    params,
  })
}

/** 合并患者(将次患者的病歷等就诊信息合并到主患者后删除次患者) */
export function mergePatient(params?: Record<string, any>, options?: Record<string, any>) {
  return request<Record<string, any>>(
    {
      url: 'UserApi/Patient/MergePatient',
      method: 'post',
      params,
    },
    {
      ...options,
    },
  )
}

/** 保存角色授权 */
export function saveRoleAuthority(params?: Object) {
  return request({
    url: 'UserApi/Role/SaveRoleAuthority',
    method: 'post',
    params,
  })
}
/** 查询角色授权 */
export function getRoleAuthorityList(params?: Object) {
  return request<Record<string, any>[]>({
    url: 'UserApi/Role/GetRoleAuthorityList',
    method: 'get',
    params,
  })
}
/** 获取用户菜单 */
export function getStaffMenu(params?: Object) {
  const start = Date.now()
  console.warn(`[getStaffMenu] 發起 ${new Date(start).toISOString()}`, params)
  return request<Record<string, any>>({
    url: 'UserApi/Menu/GetStaffMenu',
    method: 'get',
    params,
  })
    .then((data) => {
      const cost = Date.now() - start
      const len = Array.isArray(data) ? data.length : data && typeof data === 'object' ? Object.keys(data).length : 0
      console.warn(`[getStaffMenu] 結束 ${new Date().toISOString()} 耗時 ${cost}ms 長度 ${len}`)
      return data
    })
    .catch((err) => {
      const cost = Date.now() - start
      const isTimeout = err?.code === 'ECONNABORTED' || /timeout/i.test(String(err?.message || ''))
      console.error(`[getStaffMenu] ${isTimeout ? '超時' : '報錯'} ${new Date().toISOString()} 耗時 ${cost}ms`, err)
      throw err
    })
}
/** 保存诊所信息 */
export function saveClinic(params: Object) {
  return request({
    url: 'UserApi/Clinic/SaveClinic',
    method: 'post',
    params,
  })
}

/** 查询诊所详情 */
// export function getClinic(params: Object) {
//   return request({
//     url: 'UserApi/Clinic/GetClinic',
//     method: 'get',
//     params,
//   })
// }

/** 写病人索引 */
export function setPatientIndex(params: Object) {
  return request({
    url: 'UserApi/Patient/SetPatientIndex',
    method: 'get',
    params,
  })
}

/** 分页查询登录日志 */
export function getLoginLogPageList(params: Record<string, any>) {
  return request<Record<string, any>>({
    url: 'UserApi/LoginLog/GetLoginLogPageList',
    method: 'post',
    params,
  })
}

/** 【StaffToStaff】分页查询授权列表 */
export function getProxyStaffToStaffPageList(params: Record<string, any>) {
  return request<Record<string, any>>({
    url: 'UserApi/ProxyStaffToStaff/GetProxyStaffToStaffPageList',
    method: 'post',
    params,
  })
}

/** 【StaffToStaff】授权（醫師→授權醫師） */
export function authorizeProxyToStaff(params: Object) {
  return request({
    url: 'UserApi/ProxyStaffToStaff/AuthorizeProxyToStaff',
    method: 'post',
    params,
  })
}

/** 【StaffToStaff】删除授权 */
export function deleteProxyStaffToStaff(params: Object) {
  return request({
    url: 'UserApi/ProxyStaffToStaff/DeleteProxyStaffToStaff',
    method: 'get',
    params,
  })
}
